export default "__VITE_ASSET__970990ff__"